import React, { useState, useEffect, useRef } from "react";
import "../../assets/styles/components/Navbars/MobileNav.css";
import {
  CircleUser,
  ChevronRight,
  ChevronLeft,
  Plus,
  Minus,
  Search,
  X,
  User,
  LogOut,
  ShoppingCart,
} from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import mobilelogo from "../../assets/images/logo-dark.png";
import { fetchMegamenuData } from "./redux/megaMenuSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import WishlistModal from "../Wishlist/WishlistModal";
import LoginPromptModal from "../LoginModal/LoginPromptModal";
import { IoLogoWhatsapp } from "react-icons/io";
// import newsdrwimage from "../../assets/images/navimage.png";
import API from "../../app/api";
import { useCartWishlist } from "../../app/CartWishlistContext";
import { getCategoryUrl, getProductPdpUrl } from "../../utils/url.utils";
import { Heart} from "lucide-react";
import { NavLink } from "react-router-dom";

const MobileNav = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { getCartWishlistCount } = useCartWishlist();
  const [isOpen, setIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("main");
  const [currentSection, setCurrentSection] = useState(null);
  const [openCategory, setOpenCategory] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showWishlist, setShowWishlist] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [showUserPopup, setShowUserPopup] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);
  const userWrapperRef = useRef(null);
  const { data } = useSelector((state) => state.megamenu);
  const [wdata, setData] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mergedCategories, setmergedCategories] = useState([]);
  const NavsetImage = data[0]?.media;
  const [activeIndex, setActiveIndex] = useState(-1);
  const visibleResults = Array.isArray(searchData)
    ? searchData.slice(0, 8)
    : [];

  const trimmedQuery = query.trim();  
   useEffect(() => {
     const el = document.querySelector(".active-item");
     if (el) {
       el.scrollIntoView({ block: "nearest" });
     }
   }, [activeIndex]);

  useEffect(() => {
  if (showSearch && inputRef.current) {
    setTimeout(() => {
      inputRef.current.focus();
    }, 100);
  }
}, [showSearch]);

  const highlightText = (text, query) => {
  if (!query) return text;
  const regex = new RegExp(`(${query})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <span key={index} className="highlight">
        {part}
      </span>
    ) : (
      part
    )
  );
};

  useEffect(() => {
    const hero_banner_categories = JSON.parse(localStorage.getItem('hero_banner_categories') || '[]');
    setmergedCategories(hero_banner_categories);
  }, [location.pathname]);
  useEffect(() => {
    chatsupport();
    dispatch(fetchMegamenuData());
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, [dispatch]);

  useEffect(() => {
    if (isOpen) {
      // Disable page scroll when drawer is open
      document.body.style.overflow = "hidden";
    } else {
      // Enable scroll when drawer is closed
      document.body.style.overflow = "auto";
    }

    // Cleanup when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  //  Check login status dynamically
  useEffect(() => {
    const checkLogin = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);
    };
    checkLogin();
    window.addEventListener("storage", checkLogin);
    return () => window.removeEventListener("storage", checkLogin);
  }, []);

  //  Close popup when clicking outside
useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearch(false);
      }
    }

    if (showSearch) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSearch]);



  const chatsupport = async () => {
    try {
      const res = await API.get("/chat/support");
      if (res.data.status === 200) setData(res.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  // const toggleDrawer = () => {
  //   setIsOpen(!isOpen);
  //   setActiveMenu("main");
  //   setCurrentSection(null);
  //   setOpenCategory(null);
  // };

  const navigateTo = (menu) => setActiveMenu(menu);
  const goBack = () => {
    if (activeMenu === "category") {
      setActiveMenu("shop");
      setCurrentSection(null);
      setOpenCategory(null);
    } else if (activeMenu === "shop") {
      setActiveMenu("main");
    }
  };

  // const toggleCategory = (id) => {
  //   setOpenCategory((prev) => (prev === id ? null : id));
  // };

const handleUserClick = (e) => {
  e.stopPropagation();
  if (!isLoggedIn) {
    setIsOpen(false);   // ✅ drawer close
    navigate("/login");
  } else {
    setShowUserPopup((prev) => !prev);
  }
};
const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("userName");
  setIsLoggedIn(false);
  setUserName("");
  setShowUserPopup(false);
  getCartWishlistCount();
  window.dispatchEvent(new Event("storage"));
  navigate("/");
};

  const handleProfile = () => {
    setShowUserPopup(false);
    navigate("/accounts/profile?tab=your%20orders");
  };

  useEffect(() => {
    if (!query.trim()) {
      setSearchData([]);
      return;
    }
    const timeoutId = setTimeout(() => {
      setLoading(true);
      handleSearch(query);
    }, 400);

    return () => clearTimeout(timeoutId);
  }, [query, dispatch]);

  const handleSearch = async (query) => {
    try {
      const res = await API.get(`search?q=${query}`);
      if (res.data.status === 200) {
        setLoading(false);
        setSearchData(res.data?.data?.products);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {

    document.body.style.overflow = showSearch ? "hidden" : "auto";
  }, [showSearch]);

  const clearSearch = () => {
    setShowSearch(false);
    setQuery("");
    setSearchData([]);
  };

  // const getMenuTitle = () => {
  //   if (activeMenu === "main") return "";
  //   if (activeMenu === "shop") return "SHOP";
  //   if (activeMenu === "category") return currentSection?.name || "";
  //   return "";
  // };




  // ✅ DRAWER TOGGLE
  // const toggleDrawer = () => {
  //   setIsOpen((prev) => !prev);

  //   const firstSection = data?.[0];

  //   if (!isOpen) {
  //     setActiveMenu("category");
  //     setCurrentSection(firstSection || null);

  //     if (firstSection?.categories?.length) {
  //       setOpenCategory(firstSection.categories[0].id);
  //     }
  //   } else {
  //     setCurrentSection(null);
  //     setOpenCategory(null);
  //   }
  // };

  const toggleDrawer = () => {
  setIsOpen((prev) => !prev);
  const firstSection = data?.[0];
  if (!isOpen) {
    setActiveMenu("category");
    setCurrentSection(firstSection || null);
    setOpenCategory(null);
  } else {
    setCurrentSection(null);
    setOpenCategory(null);
  }
};


    // ✅ CATEGORY TOGGLE
  const toggleCategory = (id) => {
    setOpenCategory((prev) => (prev === id ? null : id));
  };

  const { countData } = useCartWishlist();

  /*-------- Search data --------*/
  
  const searchRef = useRef();
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowSearch(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const words = [
    "WHAT ARE YOU LOOKING FOR CARPETS",
    "WHAT ARE YOU LOOKING FOR BATHMATS",
    "WHAT ARE YOU LOOKING FOR DUSTBIN",
    "WHAT ARE YOU LOOKING FOR ORGANISERS",
  ];

  const [wordIndex, setWordIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentWord = words[wordIndex];

    let typingSpeed = isDeleting ? 50 : 100;

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        // typing
        setDisplayText(currentWord.substring(0, displayText.length + 1));

        if (displayText === currentWord) {
          // pause before deleting
          setTimeout(() => setIsDeleting(true), 1200);
        }
      } else {
        // deleting
        setDisplayText(currentWord.substring(0, displayText.length - 1));

        if (displayText === "") {
          setIsDeleting(false);
          setWordIndex((prev) => (prev + 1) % words.length);
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, wordIndex]);



  useEffect(() => {
  const checkLogin = () => {
    const token = localStorage.getItem("token");
    const name = localStorage.getItem("userName");

    setIsLoggedIn(!!token);
    setUserName(name || "");
  };

  checkLogin();
  window.addEventListener("storage", checkLogin);
  return () => window.removeEventListener("storage", checkLogin);
}, []);
const [userName, setUserName] = useState("");
 

  return (
    <>
      {/* HEADER */}

      <header className="topbar">
        <div className="topbar-left">
          <div className="hamburger" onClick={toggleDrawer}>
            <i className="bi bi-list"></i>
          </div>

          <div onClick={() => navigate("/")}>
            <img src={mobilelogo} width={160} alt="logo" />
          </div>
        </div>

       <div className="icons">
                {/* <Search
                  color="black"
                  strokeWidth={1.0}
                  onClick={() => setShowSearch(true)}
                  className="search-icon"
                /> */}

               <Search
                color="black"
                strokeWidth={1.0}
                onClick={() => setShowSearch(prev => !prev)}
                className="search-icon"
              />
  
                 <div className="icon-wrapper wishlist-icon-wrapper m003">
                 <Heart size={22} color="#000000" strokeWidth={1}/> 

                    <span className="wishlist-badge_mlb" style={{ background:"#d52326", left:"12px"}}>
                      {countData.wishlist_count}
                    </span>
               </div>
 
                 <NavLink to="/cart" className="tab-item cart-tab">
                  {({ isActive }) => (
                    <div className="icon-wrapper cart-icon-wrapper">
                      <ShoppingCart  
                        size={22}
                        color={isActive ? "#000" : "#020202"}

                        strokeWidth={1}/>
                        <span className="cart-badge_mlb" style={{ background:"#d52326"}}>{countData.cart_count}</span>
                    </div>
                  )}
               </NavLink>
        </div>
      </header>

  {showSearch && (
        <header className="topbar-search">
          <div className="searchsection-box">
            <input
              type="search"
              className="input"

               placeholder={displayText || "WHAT ARE YOU LOOKING FOR..."}
              autoFocus
            />
            <span className="searchicon">
              <i className="bi bi-search"></i>
            </span>
           
             <span style={{ position:"absolute", color:"rgb(113 108 108)", fontSize:"6px", right:"9px"}}> <X className="close-search" onClick={clearSearch} style={{ width:"14px"}} /> </span> 
          </div>
        </header>
      )}


      {/* DRAWER */}
      
   <div className={`drawer ${isOpen ? "open" : ""}`}>
  <div className="drawer-header">
    <img src={mobilelogo} width={160} alt="logo" />
    <span onClick={toggleDrawer} style={{ cursor: "pointer" }}>✕</span>
  </div>
  <div className="menu active" style={{ borderTop: "1px solid #e7dede", position:"relative" }}>
    <ul>
      {data?.length === 0 && (
        <li style={{ padding: "10px" }}>No Categories Found</li>
      )}

      {data?.map((category) => (
        <li key={category.id}>
          {/* CATEGORY */}
          <div
            className="iteam_main"
            onClick={() => toggleCategory(category.id)}
            >
            {/* <div><Link to={category.actionLink}> {category.name} </Link></div> */}
            <div> {category.name} </div>
            <div>
              {openCategory === category.id ? (
                <i className="bi bi-chevron-down"></i>
              ) : (
                <i className="bi bi-chevron-right"></i>
              )}
            </div>
          </div>

          {/* SUBCATEGORY */}
          {openCategory === category.id && (
            <ul className="submenu">
              {category.subcategories?.length > 0 ? (
                category.subcategories.map((sub) => (
                  <li key={sub.id}>
                    <Link
                       to={`${category.actionLink}/${sub.actionLink}`}
                      onClick={toggleDrawer}
                    >
                      {sub.name}
                    </Link>
                  </li>
                ))
              ) : (
                <li style={{ padding: "8px 10px" }}>
                  No Subcategories
                </li>
              )}
            </ul>
          )}
        </li>
      ))}
    </ul>
  </div>
  <div className="login-sectionmobile">
    <ul className="loginlistbox">
     <li onClick={handleUserClick}>
  <Link>
    <CircleUser size={23} strokeWidth={1} style={{ paddingRight:"5px"}} />

    {!isLoggedIn ? (
      <span>Login / Register</span>
    ) : (
      <span className="user-name">
        {userName || "User"}
      </span>
    )}
  </Link>

  {!isLoggedIn && (
    <span className="signin-m">
      Sign in
    </span>
   )}
  </li>
        {isLoggedIn && (
       <li onClick={handleProfile}><Link> <i class="bi bi-person" style={{ fontSize:"18px"}}></i> My Profile  </Link>  
       {/* <span style={{ float:"right"}}> <i class="bi bi-chevron-right"></i> </span>  */}
       </li>
        )}
       {isLoggedIn && (
          <li onClick={handleLogout}>
            <Link>
              <i className="bi bi-box-arrow-left" style={{ fontSize: "18px" }}></i> Logout
            </Link>
          </li>
      )}
    </ul>
  </div>
</div>

      {/* OVERLAY */}
      {isOpen && <div className="overlay" onClick={toggleDrawer}></div>}

      {/* SEARCH */}
       {isOpen && <div className="overlay" onClick={toggleDrawer}></div>}
      {showWishlist && <WishlistModal onClose={() => setShowWishlist(false)} />}
      {showLoginPrompt && (
        <LoginPromptModal onClose={() => setShowLoginPrompt(false)} />
      )}

      {/* {showSearch && (
        <div className="search-fullscreen" onClick={clearSearch}>
          <div
            className="search-sheet"
            onClick={(e) => e.stopPropagation()}
          >
           
            <div className="search-header">
              <Search size={20} strokeWidth={1.4} />
                  <input
                  ref={inputRef}
                  type="text"
                  className="search-input"
                  placeholder="WHAT ARE YOU LOOKING FOR ?"
                  value={query}
                  autoFocus
                  onClick={(e) => e.stopPropagation()} 
                  onChange={(e) => {
                    let value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                    value = value.replace(/^\s+/, "");
                    setQuery(value);
                  }}
                                onKeyDown={(e) => {
                      if (!visibleResults.length) return;
                  
                     
                      if (e.key === "ArrowDown") {
                        e.preventDefault();
                        setActiveIndex((prev) =>
                          prev < visibleResults.length - 1 ? prev + 1 : 0
                        );
                      }
                  
                     
                      if (e.key === "ArrowUp") {
                        e.preventDefault();
                        setActiveIndex((prev) =>
                          prev > 0 ? prev - 1 : visibleResults.length - 1
                        );
                      }
                  
                     
                      if (e.key === "Enter") {
                        e.preventDefault();
                  
                        if (activeIndex >= 0) {
                          const item = visibleResults[activeIndex];
                          clearSearch();
                        } else if (query.trim()) {
                          clearSearch();
                          navigate(`/search?q=${encodeURIComponent(trimmedQuery)}`);
                        }
                      }
                    }}
                />

              <X className="close-search" onClick={clearSearch} />
            </div>

       
            {loading ? (
              <div className="loader-box">
                <div className="spinner-border text-secondary" />
              </div>
            ) : (
              <>
                {Array.isArray(searchData) && searchData.length > 0 && (
                  <div className="search-results-wrapper">

                   {visibleResults.map((item, i) => (
                     <Link
                       key={i}
                       to={getProductPdpUrl(item.action_url, item.sku)}
                       className={`search-result-row ${
                         i === activeIndex ? "active-item" : ""
                       }`}
                       onMouseEnter={() => setActiveIndex(i)} 
                       onClick={clearSearch}
                     >
                       <img
                         src={item.media_list?.main?.file}
                         alt={item.name}
                         className="result-thumb"
                       />
                   
                       <div className="result-info">
                         <p>
                           {highlightText(
                             item.name?.split(" ").slice(0, 10).join(" "),
                             query
                           )}
                         </p>
                       </div>
                     </Link>
                   ))}
                  </div>
                )}
             
                {!query &&
                  <div className="search-results-wrapper rap-nores">
                    {mergedCategories.slice(0, 8).map((item, i) => (
                      <Link
                        to={getCategoryUrl(item.action_url)}
                        className="search-result-row"
                        key={i}
                        onClick={clearSearch}
                      >
                        <img
                          src={item.media}
                          alt={item.name}
                          className="result-thumb-nores"
                        />
                        <div className="result-info">
                          <p>{item.name}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                }
              </>
            )}
          </div>
        </div>
      )} */}

             <a
              href={`https://api.whatsapp.com/send?phone=${wdata?.phone}&text=${wdata?.text}`}
              className="floating-whatsapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IoLogoWhatsapp className="whatsapp-icon" />
            </a>


    </>
  );
};
export default MobileNav;